import axios from 'axios';
import type { PublicClientApplication } from '@azure/msal-browser';
import { sessionStorageService } from '../../utils/helpers/sessionStorageService';

const TOKEN_SCOPES = ['User.Read'];

export const setupAxiosInterceptors = (msalInstance: PublicClientApplication) => {
  axios.interceptors.request.use(async (config) => {
    const account = msalInstance.getAllAccounts()[0];
    if (!account) return config;

    try {
      const result = await msalInstance.acquireTokenSilent({
        account,
        scopes: TOKEN_SCOPES,
      });

      sessionStorageService.set('msal.active.token', result.idToken);

      if (config.headers) {
        config.headers['Authorization'] = `Bearer ${result.idToken}`;
      }
    } catch {
      // Silent refresh failed — the 401 interceptor will handle re-auth
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error: unknown) => {
      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status === 401) {
        const account = msalInstance.getAllAccounts()[0];
        await msalInstance.loginRedirect({
          account: account ?? undefined,
          scopes: TOKEN_SCOPES,
        });
      }
      return Promise.reject(error);
    }
  );
};
